import {Component} from "../Component.js";
import {WavePageTransition} from "../../WavePageTransition";


export class PageLoader extends Component {
    static name = "page-loader";

    static ShowEvent = "page-loader:show";

    static HideEvent = "page-loader:hide";

    get name() {
        return PageLoader.name;
    }

    constructor(el) {
        super(el);

        this.pageTransition = new WavePageTransition(document.querySelector(".wave-transition"));

        window.pageTransition = this.pageTransition;

        this.addEventListener(document.body, PageLoader.ShowEvent, this.onShowPageLoader.bind(this));
        this.addEventListener(document.body, PageLoader.HideEvent, this.onHidePageLoader.bind(this));

        this.el.classList.add("--initialized");
    }

    /**
     * @param {CustomEvent|undefined} e
     */
    onShowPageLoader(e) {

        this.el.classList.add("--opening");
        this.pageTransition.show().then(() => {
            this.el.classList.remove("--opening");
            this.el.classList.add("--opened");

            e?.detail?.onComplete?.call(null);
        });
    }

    /**
     * @param {CustomEvent|undefined} e
     */
    onHidePageLoader(e) {
        this.el.classList.add("--closing");
        this.pageTransition.hide().then(() => {
            this.el.classList.remove("--closing");
            this.el.classList.remove("--opened");

            e.detail.onComplete?.call(null);
        });
    }

    /**
     * Triggers show event on {el}
     * @param {HTMLElement} el
     */
    static show(el) {
        return new Promise((res, rej) => {
            document.body.dispatchEvent(new CustomEvent(PageLoader.ShowEvent, {detail: {
                onComplete: res
            }}))
        });
    }

    /**
     * Triggers hide event on {el}
     * @param {HTMLElement} el
     */
    static hide(el) {
        return new Promise((res, rej) => {
            document.body.dispatchEvent(new CustomEvent(PageLoader.HideEvent, {detail: {
                onComplete: res
            }}))
        });
    }
}
